import {getPaymentProcessorBaseURL} from "../helpers";


const STRIPE_PAYMENT_PROCESS = {
    stripeClientConfig:     `${getPaymentProcessorBaseURL()}/PaymentsGlobal/StripeConfig`,
    createPaymentIntent:    `${getPaymentProcessorBaseURL()}/PaymentsGlobal/CreatePaymentIntent`,
    upgrade:                `${getPaymentProcessorBaseURL()}/PaymentsGlobal/DonorUpdateDonation`,
    createSubscription:     `${getPaymentProcessorBaseURL()}/PaymentsGlobal/CreateSubscription`,
    createCheckoutSession:  `${getPaymentProcessorBaseURL()}/PaymentsGlobal/CreateCheckoutSession`,
    sessionStatus:          `${getPaymentProcessorBaseURL()}/PaymentsGlobal/SessionStatus`,
};

export function AddStripeV3JsTag() {
 const script = document.createElement("script");
  script.src = "https://js.stripe.com/v3/";
  script.type = "text/javascript";
  script.charset = 'utf-8';
  script.defer = true;
  document.head.append(script);
}

export function AddStripeBasilJsTag() {

  const scriptStripeJs = document.createElement("script");
  scriptStripeJs.src = "https://js.stripe.com/basil/stripe.js";
  scriptStripeJs.type = "text/javascript";
  scriptStripeJs.charset = 'utf-8';
  scriptStripeJs.defer = true;
  document.head.append(scriptStripeJs);
}
export const getStripeClientConfigURL = (type = "stripeClientConfig") => {
  return STRIPE_PAYMENT_PROCESS[type];
}
export const getStripeSessionURL = (type = "createPaymentIntent") => {
  return STRIPE_PAYMENT_PROCESS[type];
}